import { useCallback } from 'react';
import { Typography, Stack } from '@mui/material';
import { useDispatch, useListeners, useSelector } from '@client/hooks/redux.hooks';
import { FormStack } from '@client/components/forms/FormStack';
import { TextField } from '@client/components/forms/TextField';
import { getSelectedProfile } from '@client/selectors/helpers/profile';
import { ProfileTypes } from '@sda/enums';
import { SignupWrapperForm } from '../../common/SignupWrapper/SignupWrapperForm';
import { signupArtistAccountsListeneners, startSaveArtistAccounts } from './signup-artist-accounts.listeners';
import { SignupArtistAccountsSchema } from './signup-artist-accounts.schema';

const Explainer = (
  <Stack spacing={2}>
    <Typography
      variant="h6"
      align="left"
    >
      Add media
    </Typography>

    <Typography
      color="textSecondary"
      align="left"
    >
      This probably isn't a surprise, but profiles with audio and video attract more attention.
    </Typography>
  </Stack>
);

export const Accounts = () => {
  const dispatch = useDispatch();
  const selectedProfile = useSelector(getSelectedProfile);

  useListeners(signupArtistAccountsListeneners);

  const initialValues = {
    spotifyArtistUrl: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.spotifyArtistUrl || '' : '',
    websiteUrl: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.websiteUrl || '' : '',
    videoUri: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.youtubeUri || '' : '',
  };

  const handleSubmit = useCallback((values: typeof initialValues) => {
    dispatch(startSaveArtistAccounts(values));
  }, [dispatch]);

  return (
    <SignupWrapperForm
      steps={6}
      currentStep={5}
      renderExplainer={Explainer}
      FormikProps={{
        initialValues,
        onSubmit: handleSubmit,
        validationSchema: SignupArtistAccountsSchema,
      }}
      buttonProps={() => ({
        scope: 'signup-act-accounts-form',
      })}
    >
      <FormStack>
        <TextField
          name="spotifyArtistUrl"
          label="Spotify profile URL"
          helperText="Displays your top songs and number of monthly listeners."
          type="url"
          fullWidth
        />

        <TextField
          name="videoUri"
          label="Youtube video URL"
          fullWidth
        />

        <TextField
          name="websiteUrl"
          label="Website"
          type="url"
          fullWidth
        />
      </FormStack>
    </SignupWrapperForm>
  );
};
